import React from "react";
import * as IMAGES from "../Images";

import "./Loader.css";

class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render = () => {
    return (
      <div className="loader-container">
        <div className="loader-image">
          <img
            src={IMAGES.BMCLOGO}
            alt="Gear Loader"
            style={{ width: "200px" }}
          />
        </div>
      </div>
    );
  };
}

export default Loader;
